<div [ngClass]="['selected-attachment-display', embeddedView() ? 'thumbnail' : 'full']" (click)="attachmentClick.emit(selectedAttachment())">
    @if (selectedAttachment()?.file?.uri) {
        <i
            class="download-button fa-download"
            [ngClass]="[teamsApp ? (buttonHovers['download-button'] ? 'fas' : 'fal') : 'fal', 'on']"
            (click)="downloadAttachment(selectedAttachment())"
            (mouseenter)="buttonHovers['download-button']=true"
            (mouseleave)="buttonHovers['download-button']=false"
        ></i>
    }

    @if (selectedCarouselAttachmentIndex() > 0) {
        <i
            class="left-next-button fa-chevron-left"
            [ngClass]="[teamsApp ? (buttonHovers['left-next-button'] ? 'fas' : 'fal') : 'fas', selectedCarouselAttachmentIndex() > 0 ? 'on' : 'off', teamsApp ? 'teams' : '']"
            (click)="onCarouselClickLeft($event)"
            (mouseenter)="buttonHovers['left-next-button']=true"
            (mouseleave)="buttonHovers['left-next-button']=false"
        ></i>
    }

    <i
        class="open-button fa-arrow-up-right-and-arrow-down-left-from-center"
        [ngClass]="[teamsApp ? (buttonHovers['open-button'] ? 'fas' : 'fal') : 'fas']"
        (mouseenter)="buttonHovers['open-button']=true"
        (mouseleave)="buttonHovers['open-button']=false"
    ></i>

    @if (selectedAttachment()?.type === 'video' && (selectedAttachment()?.file?.uri || videoBlobUrl())) {
        <i
            class="play-button fa-play"
            [ngClass]="[teamsApp ? (buttonHovers['play-button'] ? 'fas' : 'fal') : 'fas']"
            (mouseenter)="buttonHovers['play-button']=true"
            (mouseleave)="buttonHovers['play-button']=false"
        ></i>
    }

    @if (selectedAttachment()?.type === 'image' && selectedAttachment()?.file?.uri || thumbnail()) {
        <app-image-preview
            [image]="thumbnail() ? selectedAttachment()?.thumbnailUri : selectedAttachment()?.file?.uri"
            [thumbnail]="selectedAttachment()?.thumbnailUri"
            [fill]="thumbnail()"
            [style]="embeddedView() ? 'height: 100%;' : ''"
        />
    }

    @if (selectedAttachment()?.type === 'video' && (selectedAttachment()?.file?.uri || videoBlobUrl()) && !thumbnail()) {
        <video
            controls
            [autoplay]="thumbnail() ? '' : 'autoplay'"
            playsinline
            [src]="selectedAttachment()?.file?.uri ?? videoBlobUrl()"
            [poster]="selectedAttachment().thumbnailUri"
            [style]="embeddedView() ? 'height: 100%; width: 100%;' : ''"
        ></video>
    }

    @if (!selectedAttachment()?.file?.uri && !videoBlobUrl()) {
        <p class="no-data pT30 pB30">{{'crews.channels.could-not-display-attachment' | translate}}</p>
    }

    @if (selectedCarouselAttachmentIndex() < attachmentList().length - 1 && selectedCarouselAttachmentIndex() !== -1) {
        <i
            class="right-next-button fa-chevron-right"
            [ngClass]="[teamsApp ? (buttonHovers['right-next-button'] ? 'fas' : 'fal') : 'fas', selectedCarouselAttachmentIndex() < attachmentList().length - 1 && selectedCarouselAttachmentIndex() !== -1 ? 'on' : 'off', teamsApp ? 'teams' : '']"
            (click)="onCarouselClickRight($event)"
            (mouseenter)="buttonHovers['right-next-button']=true"
            (mouseleave)="buttonHovers['right-next-button']=false"
        ></i>
    }
</div>
